<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsCitySelect',
  
})
</script>
<template>
  <div
    class="tlbs-cityselect-container"
  >
    <t-cascader
      v-model="selectValue"
      :options="options"
      v-bind="$attrs"
      @change="onChange"
    />
  </div>
</template>

<script setup lang="ts" name="TlbsCitySelect">
import jsonp from 'fetch-jsonp';
import { onMounted, watch } from 'vue';
interface Props {
  modelValue: string;
  nameType?: 'name' | 'fullname'
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '',
  nameType: 'fullname',
});

interface DistrictData{
  id: string;
  name: string;
  fullname: string;
  pinyin: string[];
  location: {
    lat: number;
    lng: number;
  }
}
interface Node{
  label: string;
  value: string;
  children: any;
  id: string;
}
const selectValue = ref(props.modelValue);
const options = ref();
let webServiceDistrictResult: DistrictData[][];
const key = 'ATRBZ-3QEN3-WCP3H-YPUPE-H54U6-C4BCG';
const provinceRequestUrl = `https://apis.map.qq.com/ws/district/v1/list?key=${key}&output=jsonp`;

watch(() => props.modelValue, (newVal) => {
  onChange(newVal);
});

onMounted(() => {
  jsonp(provinceRequestUrl).then(response => response.json())
    .then((data) => {
      if (data && data.status === 0) {
        webServiceDistrictResult = data.result;
        options.value = getNodeData(webServiceDistrictResult);
      } else {
        console.error(`webServiceDistrict请求失败: ${data.status}`);
      }
    })
    .catch((err) => {
      console.log('json parsing failed', err);
    });
});
const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void,
  (e: 'change', value: DistrictData | null): void
}>();
const onChange = (value: string) => {
  selectValue.value = value;
  const [provinceArr, cityArr, districtArr] = webServiceDistrictResult;
  const allDistrict = [...provinceArr, ...cityArr, ...districtArr];
  let findedDistrict;
  if (value) {
    findedDistrict = allDistrict.find(district => district.id === value);
  } else {
    findedDistrict = null;
  }
  emit('update:modelValue', value);
  emit('change', findedDistrict || null);
};
const getNodeData = (sourceData: DistrictData[][]): Node[] => {
  const res: Node[] = [];
  const [provinceArr, cityArr, districtArr] = sourceData;
  provinceArr.forEach((item) => {
    const currentProvince = formatData(item);
    const filterCurrentCity = cityArr.filter(city => item.id.slice(0, 2) === city.id.slice(0, 2));

    const currentCityList = filterCurrentCity.map((city) => {
      const filterDistrictList = districtArr.filter(district => district.id.slice(0, 4) === city.id.slice(0, 4));
      const currentDistrict = filterDistrictList.map(district => formatData(district));
      const formatCity = formatData(city);
      formatCity.children = currentDistrict;
      return formatCity;
    });
    currentProvince.children = currentCityList;
    res.push(currentProvince);
  });
  return res;
};

const formatData = (item: DistrictData) => {
  if (!item) return {};
  return {
    label: item[props.nameType],
    value: item.id,
    children: [],
    id: item.id,
  };
};
</script>

<style lang="less">
.tlbs-cityselect-container {
  width: 228px;
}
</style>
